import http from '../http'

export default {
  // 获取用户设置的提现支付列表
  getWithdrawMethodList(data: object) {
    return http.get('/web/withdrawal/method/list', data)
  },
  // 获取渠道列表
  getWithdrawChannelList(data: object) {
    return http.get('/web/withdrawal/channel/list', data)
  },
  // 创建新的支付方式
  createWithdrawMethod(data: object) {
    return http.post('/web/withdrawal/method/create', data)
  },
  // 更新支付方式
  updateWithdrawMethod(data: object) {
    return http.post('/web/withdrawal/method/update', data)
  },
  // 删除支付方式
  deleteWithdrawMethod(data: object) {
    return http.post('/web/withdrawal/method/delete', data)
  },
  // 创建提现订单
  createWithdrawOrder(data: object) {
    return http.post('/web/withdrawal/order', data)
  },
  // 获取提现配置
  getWithdrawConfig(data: object) {
    return http.get('/web/withdrawal/config', data)
  },
  // 主播获取订单列表
  getAnchorWithdrawOrderList(data: object) {
    return http.post('/web/withdrawal/order/list', data)
  },
  // 代理获取订单列表
  getAgentWithdrawOrderList(data: object) {
    return http.post('/web/withdrawal/agent/order/list', data)
  },
  // 拒绝订单
  refuseWithdrawOrder(data: object) {
    return http.post('/web/withdrawal/agent/order/refuse', data)
  },
  // 代理确认订单
  confirmWithdrawOrder(data: object) {
    return http.post('/web/withdrawal/agent/order/confirm', data)
  },
  // 用户确认订单
  confirmUserWithdrawOrder(data: object) {
    return http.post('/web/withdrawal/order/confirm', data)
  },
  // 订单转售后
  transferAfterSale(data: object) {
    return http.post('/web/withdrawal/order/dispute', data)
  },
}
